import React from 'react';

const InboxChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5v14h16V5H4zm14 12H6v-5h2.1c.4 1.7 2 3 3.9 3s3.4-1.3 3.9-3H18v5zm0-7h-4v1c0 1.1-.9 2-2 2s-2-.9-2-2v-1H6V7h12v3z"
        />
    </svg>
);

InboxChunkySvg.displayName = 'InboxChunkySvg';
export default InboxChunkySvg;
